const projects = [
  {
    slug: "kashima-website",
    title: "KASHIMA",
    description: "discord bot",
    fullDescription: "This project is a redesign of the original [website] Kashima website [/website], serving as a central hub to showcase [website] Kashima’s features [/website] and provide an intuitive web-based music player and controller. The new site allows users to easily queue, pause, and control music playback without needing to type commands manually, making music management seamless on the go. Additionally, the website offers a convenient interface for users to configure Kashima’s settings directly. enhancing user experience by simplifying bot management.",
    year: "2025",
    role: "Web Developer & Designer",
    collaborators: ["Saya", "0t4u"],
    tools: ["React", "Figma", "Node", "Aseprite", "Tailwind CSS"],
    duration: "TBA",
    client: "Shipgirls Project",
    tags: ["Web Design", "React", "Tailwind CSS"],
    website: "https://kashima.saya.moe/",
    website1: "https://discord.bots.gg/bots/424137718961012737",
    image: "https://imgur.com/iX3uAbb.png",
    gallery: [
      "https://i.imgur.com/TdD0Wjm.png",
      "https://i.imgur.com/extra-image1.png",
      "https://i.imgur.com/extra-image2.png"
    ]
  },
];

export default projects;